import { Modal, ModalProps, Table, TableColumnsType } from 'antd';
import dayjs from 'lib/dayjs';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { StatusHistory } from 'services/api/refund';

export interface StatusHistoryModalProps extends ModalProps {
  data: StatusHistory[];
}

export const useStatusLabel = () => {
  const { t } = useTranslate();

  return useMemo<Record<Conversation.Trade.LazadaDisplayStatus, string>>(() => {
    return {
      REQUEST_INITIATE: t(
        'scene.orderWorkspace.returnRefundTab.detail.status.buyerInitiatedReturn',
      ),
      BUYER_RETURN_ITEM: t('scene.orderWorkspace.returnRefundTab.detail.status.buyerReturned'),
      SELLER_AGREE_RETURN: t(
        'scene.orderWorkspace.returnRefundTab.detail.status.waitingBuyerReturn',
      ),
      CS_APPROVING: t('scene.orderWorkspace.returnRefundTab.detail.status.platformReviewing'),
      SELLER_AGREE_REFUND: t('scene.orderWorkspace.returnRefundTab.detail.status.waitingRefund'),
      REFUND_PENDING: t('scene.orderWorkspace.returnRefundTab.detail.status.waitingRefund'),
      REFUND_SUCCESS: t('scene.orderWorkspace.returnRefundTab.detail.status.refundSuccess'),
      REQUEST_CANCEL: t('scene.orderWorkspace.returnRefundTab.detail.status.buyerCancelled'),
      SELLER_REJECT_RETURN: t(
        'scene.orderWorkspace.returnRefundTab.detail.status.sellerRejectedReturn',
      ),
      SELLER_REJECT_REFUND: t(
        'scene.orderWorkspace.returnRefundTab.detail.status.sellerRejectedRefund',
      ),
      REFUND_REJECT: t('scene.orderWorkspace.returnRefundTab.detail.status.sellerRejectedRefund'),
      REQUEST_REJECT: t('scene.orderWorkspace.returnRefundTab.detail.status.sellerRejectedRequest'),
    };
  }, [t]);
};

function StatusHistoryModal(props: StatusHistoryModalProps) {
  const { data, ...otherProps } = props;

  const { t } = useTranslate();

  const statusLabel = useStatusLabel();

  const columns: TableColumnsType<StatusHistory> = [
    {
      key: 'returnStatus',
      dataIndex: 'returnStatus',
      title: t('domain.returnRefund.field.status'),
      render: (status: StatusHistory['returnStatus']) => statusLabel[status] || '-',
    },
    {
      key: 'updateTimeMs',
      dataIndex: 'updateTimeMs',
      title: t('scene.orderWorkspace.returnRefundTab.detail.action.changeDate'),
      render: (time: StatusHistory['updateTimeMs']) =>
        dayjs(Number(time)).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <Modal
      title={t('scene.orderWorkspace.returnRefundTab.detail.section.statusHistory')}
      width={582}
      footer={null}
      {...otherProps}
    >
      <Table dataSource={data} columns={columns} pagination={false} />
    </Modal>
  );
}

export default StatusHistoryModal;
